/**
 * Created by superman on 17/2/16.
 */
import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    activeAppId: '',
    isAdmin: false,
    activeId3th: '',
    activeId2th: '',
    MenuId: [],
    MenuList2th: [],
    MenuList3th: [],
    typeOfAppList: [],
    pageName: 'Doc',
    searchKey: '',
    userName: '',
    orgId: '',
    orgLogo: '',
    token: null,
    title: '',
    userId: '',
    tenantId: '',
    roleIdList: [],
    orgName: '',
    gateway_url: window.location.origin + '/api',
    login_url: window.location.origin,
    eco_url: 'http://open.teewon.net',
    client_secret: '4149bcc45a16e2f3',
    sectionDic: {},
    subjectDic: {},
    areaName: '',
    systemConfig: {},
    user2OrgList: [],
    weakPwdFlag: false,
    lang: window.localStorage.getItem('tw_i18n_local') || 'zh_CN',
    hasDoc: true,
    editor: {
      goEdit: false,
      isAdmin: false,
      isEditing: false
    }
  },
  mutations: {
    'login': (state, data) => {
      // localStorage.token = data
      state.token = data[0]
      state.orgId = data[1] === 'null' ? '' : data[1]
      state.userName = data[2]
      state.userId = data[3]
      state.tenantId = data[4]
      state.orgName = data[5]
      state.roleIdList = data[6]
      state.areaName = data[7]
      state.user2OrgList = data[8]
    },
    'logout': (state) => {
      // localStorage.removeItem('token');
      state.token = null
      state.userId = ''
      state.userName = ''
      state.userId = ''
      state.tenantId = ''
      state.orgName = ''
      state.roleIdList = []
      state.orgLogo = ''
      state.areaName = ''
      state.weakPwdFlag = false
    },
    'roles': (state, data) => {
      state.roles = data
    },
    'orgLogo': (state, data) => {
      state.orgLogo = data
    },
    'systemConfig': (state, data) => {
      state.systemConfig = data
    },
    'weakPwdFlag': (state, data) => {
      state.weakPwdFlag = data
    },
    'changePageName': (state, data) => {
      state.pageName = data
    },
    'changeMenuList2th': (state, data) => {
      state.MenuList2th = data
    },
    'changeMenuList3th': (state, data) => {
      state.MenuList3th = data
    },
    'changeMenuId': (state, data) => {
      state.MenuId = data
    },
    'hasDoc': (state, data) => {
      state.hasDoc = data
    },
    'changeTypeOfAppList': (state, data) => {
      state.typeOfAppList = data
    },
    'changeActiveId2th': (state, data) => {
      state.activeId2th = data
    },
    'changeActiveAppId': (state, data) => {
      state.activeAppId = data
    },
    'changeActiveId3th': (state, data) => {
      state.activeId3th = data
    },
    'areYouAdmin': (state, data) => {
      state.isAdmin = data
    },
    'changeUrl': (state, data) => {
      state.gateway_url = data
    },
    'changeLoginUrl': (state, data) => {
      state.login_url = data
    }
  }
})



// WEBPACK FOOTER //
// ./src/config/store.js